import { loadable } from '../../../utils';

export const Options = loadable(() => import('./Options'), {});
